<template>
  <div class="container">
    <!--头图-->
    <div class="main-top" id="top"></div>
    <!-- 导航 -->
    <div class="tab" ref="tab">
      <div :class="['tab-list', positionType ? 'fixup' : '']">
        <div
          :class="['item', selectedIndex === index ? 'item-active' : '']"
          v-for="(item, index) in topList"
          :key="item.index"
          @click="changeTab(index, $event, item.navigate)"
        >
          <div>{{ item.navigate }}</div>
          <span class="bot-line"></span>
        </div>
      </div>
    </div>
    <div class="bottom-content">
      <div class="main">
        <!-- 决赛路线 -->
        <router-lines id="module1"></router-lines>
        <!-- 精彩直播 -->
        <bright-points id="module2"></bright-points>
        <!-- 精彩视频 -->
        <look-video
          id="module3"
          v-if="videoList.length"
          :videoList="videoList"
        ></look-video>
        <!-- 精美图赏 -->
        <enjoy-img
          id="module4"
          v-if="imgList.length"
          :imgList="imgList"
        ></enjoy-img>
        <!--精彩图文-->
        <related-information
          id="module5"
          v-if="informationList.length"
          :informationList="informationList"
        ></related-information>
      </div>
    </div>
    <suspend
      :topIconFlag="topIconFlag"
      toTopClass=".container"
      @returnScrollTop="returnScrollTop"
    ></suspend>
  </div>
</template>

<script>
import XHR from '../api'
import BrightPoints from '../components/BrightPoints'
import EnjoyImg from '../components/EnjoyImg'
import LookVideo from '../components/LookVideo'
import RelatedInformation from '../components/RelatedInformation'
import RouterLines from '@/components/RouteLines.vue'
import Suspend from '@/components/Suspend.vue'

export default {
  name: 'Home',
  components: {
    BrightPoints,
    EnjoyImg,
    // eslint-disable-next-line vue/no-unused-components
    LookVideo,
    RelatedInformation,
    RouterLines,
    Suspend
  },
  data: () => ({
    // tab切换index
    selectedIndex: 0,
    // 是否吸顶
    positionType: false,
    topList: [
      {
        navigate: '决赛路线'
      },
      {
        navigate: '精彩直播'
      },
      {
        navigate: '精彩视频'
      },
      {
        navigate: '精美图集'
      },
      {
        navigate: '精彩图文'
      }
    ],
    listData: [],
    hid: '',
    // 主会场数据
    // 视频数据
    videoList: [],
    // 图集数据
    imgList: [],
    // 文章资讯
    informationList: [],
    lastTime: null,
    // 返回顶部
    topIconFlag: false
  }),
  created () {
    this.init()
  },
  mounted () {
    window.addEventListener(
      'scroll',
      () => {
        this.listenScroll()
      },
      false
    )
  },

  beforeDestroy () {
    window.removeEventListener('scroll', this.listenScroll())
  },

  methods: {
    returnScrollTop (childValue) {
      if (childValue) {
        this.selectedIndex = 0
      }
    },
    // 点击悬浮导航
    changeTab (index, ev, navigate) {
      // 解决连续多次点击某一吸底，页面会一致向下移动，并且会触发选中别的按钮
      ev.preventDefault()
      const nowTime = new Date().getTime()
      if (this.selectedIndex === index || nowTime - this.lastTime < 500) {
        return
      }
      this.lastTime = nowTime
      if (!document.querySelector(`#module${index + 1}`)) {
        this.tips('敬请期待！', 'tip')
        return
      }
      this.selectedIndex = index
      const scrollNum =
        document.querySelector(`#module${index + 1}`).offsetTop - 100
      window.scrollTo(0, scrollNum)
      this.setAnalytics('解放j6x|主页面|tab标签', navigate)
    },
    // 初始化数据
    init () {
      // 主页面视频，图集，图文
      this.getData({
        methods: 'getHandWork',
        name: 'listData',
        options: {
          type: 39,
          hid: 4892
        }
      })
    },
    /**
     * @Author: zhaowei
     * @description: 手工位接口请求
     * @param: {String} methods 接口名
     * @param: {String} name 声明data参数名
     * @param: {Object} options 接口参数
     * @Date: 2020-06-16 10:57:20
     */
    getData ({ methods, name, options = {} }) {
      XHR[methods](options).then(res => {
        // 隐藏loading
        const { status, data } = res.data
        if (!status && data.length) {
          this[name] = data
          if (name === 'listData') {
            this.videoList = data[0].info
            this.imgList = data[1].info
            this.informationList = data[2].info
          }
        }
      })
    },
    // 监听页面滚动,模块导航激活
    listenScroll () {
      const clientHeight = document.documentElement.clientHeight
      const navList = document.querySelectorAll('.tab-list div')
      const scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop
      // 头图高
      const headerTop = document.querySelector('.main-top').offsetHeight
      this.$nextTick(res => {
        // 模块导航激活样式
        const scrollHeight = document.documentElement.scrollHeight
        this.activeModuleNav(
          scrollTop,
          headerTop,
          navList,
          scrollHeight,
          clientHeight
        )
      })
    },

    // 模块导航激活
    activeModuleNav (scrollTop, headerTop, navList, scrollHeight, clientHeight) {
      this.topIconFlag = scrollTop > 750
      if (!this.$refs.tab) return
      const discountTop = this.$refs.tab.offsetTop
      if (scrollTop < discountTop) {
        this.positionType = false
      } else {
        this.positionType = true
      }
      // pc控制导航fixed
      this.pcNavFixedFlag = scrollTop > 670
      if (scrollTop < headerTop) {
        this.navActived = 0
        return
      }
      for (let i = 0; i < Array.from(navList).length; i++) {
        const num = i + 1
        const index = document.querySelector(`#module${num}`)
        if (
          index &&
          index.style.display !== 'none' &&
          scrollTop >= index.offsetTop - 160
        ) {
          this.selectedIndex = i
        }
      }
      // 解决最后一个模块高度不够滑不到
      if (scrollHeight <= clientHeight + scrollTop) {
        this.selectedIndex = navList.length - 1
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  background: #0e316b
    url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/pc-bg.png');
  background-repeat: repeat-y;
  background-size: 100%;
  padding-bottom: 50px;
}
.main-top {
  background: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/m-top.jpg')
    no-repeat 50% 50%;
  height: 556px;
  width: 100%;
}
// 导航
.tab {
  width: 100%;
  height: 102px;
  margin-top: -56px;
  position: relative;
  .tab-list {
    width: 735px;
    height: 102px;
    background-image: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/nav-bg.png');
    background-repeat: repeat;
    margin: 0 auto;
    display: flex;
    &.fixup {
      position: fixed;
      z-index: 2000;
      left: 50%;
      top: -7px;
      transform: translate(-50%, 0);
      -webkit-animation: showTopNav ease-in-out 0.5s;
      animation: showTopNav ease-in-out 0.5s;
      box-sizing: border-box;
      background-repeat: repeat;
      background-image: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/nav-bg.png');
    }
    .item {
      cursor: pointer;
      color: #8be5ff;
      border-radius: 4px;
      font-size: 24px;
      font-weight: bolder;
      text-align: center;
      line-height: 102px;
      flex: 1;
      position: relative;
      div {
        color: #8be5ff;
      }

      .bot-line {
        width: 0;
        height: 2px;
        background: #fff;
        position: absolute;
        bottom: 25px;
        left: 50%;
        transform: translateX(-50%);
        opacity: 0;
        transition: 0.3s;
      }
    }
    .item-active {
      div {
        color: #fff;
      }

      .bot-line {
        width: 50%;
        opacity: 1;
      }
    }
  }
}
@media screen and (min-width: 751px) {
  .tab {
    .item {
      transition: 0.3s;
      &:hover {
        color: #fff;
        .bot-line {
          width: 50%;
          opacity: 1;
        }
        div {
          color: #fff;
        }
      }
    }
  }
  .main-top {
    height: 554px;
    max-width: 1920px;
    margin: 0 auto;
    background: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/pc-top.jpg')
      no-repeat 50% 50%;
  }
  .main {
    width: 750px;
    margin: 0 auto;
  }
  .pc-bg {
    display: block;
    background: url('https://s-test.kcimg.cn/topic/images/2021-jiefangj6x/pc-bg.png');
  }
}
/deep/.ele-title {
  width: 100%;
  text-align: center;
  margin: 60px auto 40px;
}
@keyframes showTopNav {
  0% {
    opacity: 0;
    -webkit-transform: translate(-50%, -50px);
    transform: translate(-50%, -50px);
  }
  100% {
    opacity: 1;
    -webkit-transform: translate(-50%, 0);
    transform: translate(-50%, 0);
  }
}
</style>
